import { render } from "./PerformanceProductTableGroupBy.vue?vue&type=template&id=046d4c8c"
import script from "./PerformanceProductTableGroupBy.vue?vue&type=script&lang=js"
export * from "./PerformanceProductTableGroupBy.vue?vue&type=script&lang=js"

import "./PerformanceProductTableGroupBy.vue?vue&type=style&index=0&id=046d4c8c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__